module.exports = __webpack_public_path__ + "img/sortmove-bricky.2397bee6.png";